import React, { useState } from "react";
import { motion } from "framer-motion"; // For animations
import Footer from "../../common/Footer";
import Nav from "../../common/Nav";

const donationPosts = [
  {
    id: 1,
    title: "Help Poor Children to Study",
    image: "https://i.pinimg.com/736x/f9/92/b8/f992b86c06b13b6d6ae655cacc5e79b0.jpg",
    description:
      '“Here\'s the information about PravasaCare, an NGO working in education:\n'
+ '# Activities of PravasaCare:\n'
+ '1. Providing Educational Opportunities: PravasaCare works to provide educational opportunities, such as scholarships to students, training for teachers, and resources for schools.\n'
+ '2. Improving Quality of Education: PravasaCare works to improve the quality of education, such as training teachers, providing additional support to students, and providing resources to schools.\n'
+ '3. Community Engagement in Education: PravasaCare works to engage the community in education, such as partnering with schools, connecting with students\' families, and organizing community events.\n'
+ '4. Technical Assistance for Education: PravasaCare works to provide technical assistance for education, such as developing online education platforms, providing digital literacy to students, and providing technical resources to schools.\n'
+ '# Objectives of PravasaCare:\n'
+ '1. Provide educational opportunities.\n'
+ '2. Improve the quality of education.\n'
+ '3. Promote community engagement in education.\n'
+ '4. Provide technical assistance for education.”',
    raised: 3500,
    goal: 5000,
  },
  {
    id: 2,
    title: "Economic development",
    image: "https://i.pinimg.com/736x/cf/a4/98/cfa49821c5372cd27cc502fd626c941b.jpg",
    description:
      'PravasaCare, an NGO, is commendable for its work in economic development! # Here\'s some information about PravasaCare\'s activities:\n'
+ '1. Economic Development: PravasaCare works towards economic development by providing employment opportunities, promoting entrepreneurship, and empowering economically.\n'
+ '2. Support for Migrant Communities: PravasaCare supports migrant communities by providing economic assistance, protecting their rights, and offering social services.\n'
+ '3. Community Development: PravasaCare engages in community development by promoting education, health, and environmental projects.\n'
+ '4. International Cooperation: PravasaCare collaborates internationally to implement projects for economic and social development.\n'
+ '# PravasaCare\'s objectives:\n'
+ '1. Promote economic development.\n'
+ '2. Support migrant communities.\n'
+ '3. Foster community development.\n'
+ '4. Enhance international cooperation.',
    raised: 2500,
    goal: 4000,
  },
  {
    id: 3,
    title: "Health",
    image: "https://i.pinimg.com/736x/ab/d9/8d/abd98df87cffc6e9e1252e01d83b6947.jpg",
    description:
      'Here\'s the information about PravasaCare, an NGO working in health:\n'
+ '# Activities of PravasaCare:\n'
+ '1. Providing Health Services: PravasaCare works to provide health services, such as regular health check-ups, providing medicines, and medical assistance.\n'
+ '2. Health Education: PravasaCare works to provide health education, such as providing health-related information, organizing health-related programs, and distributing health-related materials.\n'
+ '3. Increasing Access to Health Services: PravasaCare works to increase access to health services, such as reaching health services to remote areas, providing health services to poor and marginalized communities.\n'
+ '4. Health Research and Development: PravasaCare works to conduct health research and development, such as developing new health solutions, conducting health-related research, and developing health-related policies.\n'
+ '# Objectives of PravasaCare:\n'
+ '1. Provide health services.\n'
+ '2. Provide health education.\n'
+ '3. Increase access to health services.\n'
+ '4. Conduct health research and development.',
    raised: 1800,
    goal: 3000,
  },
  {
    id: 4,
    title: "Elderly Care",
    image: "https://i.pinimg.com/736x/cb/4b/ae/cb4baece6f8f2541b07e58c8c9676f28.jpg",
    description:
      'Here\'s the information about PravasaCare, an NGO working in elderly care:\n'
+ '# Activities of PravasaCare:\n'
+ '1. Residential Services for the Elderly: PravasaCare provides residential services for the elderly, such as old age homes, orphanages, and other residential facilities.\n'
+ '2. Health Services for the Elderly: PravasaCare provides health services for the elderly, such as regular health check-ups, providing medicines, and medical assistance.\n'
+ '3. Recreational and Social Activities for the Elderly: PravasaCare organizes recreational and social activities for the elderly, such as games, music, and other social activities.\n'
+ '4. Support and Counseling Services for the Elderly: PravasaCare provides support and counseling services for the elderly, such as mental health support, financial support, and other support services.\n'
+ '# Objectives of PravasaCare:\n'
+ '1. Provide residential services for the elderly.\n'
+ '2. Provide health services for the elderly.\n'
+ '3. Organize recreational and social activities for the elderly.\n'
+ '4. Provide support and counseling services for the elderly.',
    raised: 1800,
    goal: 3000,
  },
];

const NGOServicePage = () => {
  const [selectedPost, setSelectedPost] = useState(null);

  const handleDonateClick = (post) => {
    setSelectedPost(post);
  };

  const closeModal = () => {
    setSelectedPost(null);
  };

  return (
    <div className="lg:w-max w-min">
        <div className="p-6">
            <Nav/>
        </div>
    <div className="bg-gray-50 min-h-screen py-12 px-4">
    
      {/* Hero Section */}
      <div className="bg-blue-900 text-white py-20  my-2   text-center">
        <h1 className="text-4xl font-bold mb-4">Welcome to PravasaCare (NGO)</h1>
        <p className="text-lg">Empowering communities through sustainable travel and tourism.</p>
      </div>

      {/* About Us Section */}
      <div className="container mx-auto px-4 py-16">
        <h2 className="text-3xl font-bold text-center mb-8">About Us</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h3 className="text-2xl font-semibold mb-4">Our Story</h3>
            <p className="text-gray-700">
              Pravasa.in NGO was founded in 2020 with a vision to promote sustainable tourism and empower local communities. We believe that travel can be a force for good, and we work tirelessly to create opportunities for underprivileged communities through tourism.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h3 className="text-2xl font-semibold mb-4">Our Vision</h3>
            <p className="text-gray-700">
              Our vision is to create a world where travel benefits everyone. We aim to bridge the gap between travelers and local communities, ensuring that tourism contributes to the economic and social development of the regions we work in.
            </p>
          </div>
        </div>
      </div>

      {/* Mission Section */}
      <div className="bg-blue-50 py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-8">Our Mission</h2>
          <p className="text-gray-700 text-center max-w-2xl mx-auto">
            Our mission is to promote sustainable tourism practices that benefit both travelers and local communities. We focus on creating meaningful travel experiences that foster cultural exchange, environmental conservation, and economic growth.
          </p>
        </div>
      </div>

      {/* Programs Section */}
      <div className="container mx-auto px-4 py-16">
        <h2 className="text-3xl font-bold text-center mb-8">Our Programs</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h3 className="text-2xl font-semibold mb-4">Community Tourism</h3>
            <p className="text-gray-700">
              We partner with local communities to develop tourism initiatives that provide sustainable livelihoods and preserve cultural heritage.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h3 className="text-2xl font-semibold mb-4">Environmental Conservation</h3>
            <p className="text-gray-700">
              Our programs focus on protecting natural resources and promoting eco-friendly travel practices.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h3 className="text-2xl font-semibold mb-4">Education & Training</h3>
            <p className="text-gray-700">
              We provide training and education to local communities to help them benefit from tourism opportunities.
            </p>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 text-center mb-12">
          <span className="text-orange-400">PravasaCare</span> - Make a Difference
        </h1>

        {/* Donation Posts */}
        <div className=" grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
          {donationPosts.map((post, index) => (
            <motion.div
              key={post.id}
              className="bg-white rounded-lg shadow-lg overflow-hidden"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-min object-cover"
              />
              <div className="p-6">
                <h2 className="text-lg font-bold text-gray-800">{post.title}</h2>
                <p className="text-gray-600 mt-2">{post.description}</p>
                <div className="mt-4">
                  {/* Progress Bar */}
                  <div className="w-full bg-gray-200 rounded-full h-4">
                    <div
                      className="bg-blue-600 h-4 rounded-full"
                      style={{
                        width: `${(post.raised / post.goal) * 100}%`,
                      }}
                    ></div>
                  </div>
                  <p className="text-sm text-gray-500 mt-2">
                    Raised: ₹{post.raised} / ₹{post.goal}
                  </p>
                </div>
                <button
                  onClick={() => handleDonateClick(post)}
                  className="mt-6 w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-orange-400 transition"
                >
                  Give a Hand
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Modal for Payment Options */}
      {selectedPost && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-96 p-6">
            <h2 className="text-xl font-bold text-gray-800">
              Support: {selectedPost.title}
            </h2>
            <p className="text-gray-600 mt-4">
              Your contribution will help us reach our goal of ${selectedPost.goal}.
            </p>
            <div className="mt-4">
              <label className="block text-gray-700 font-medium">
                Enter Donation Amount:
              </label>
              <input
                type="number"
                placeholder="Enter amount"
                className="w-full border border-gray-300 rounded-lg p-2 mt-2"
              />
            </div>
            <div className="mt-6">
              <button className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition">
                Donate Now
              </button>
              <button
                onClick={closeModal}
                className="w-full bg-gray-300 text-gray-800 py-2 rounded-lg mt-2 hover:bg-gray-400 transition"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    <Footer/>
    </div>
  );
};

export default NGOServicePage;
